import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Chip, Typography, ClickAwayListener } from '@material-ui/core';

const DetailedChip = ({ option, classes, label, ...props }) => {
  const [isChipDetailed, setIsChipDetailed] = useState(false);

  const toggleDetailedView = (event) => {
    event.stopPropagation();
    setIsChipDetailed(!isChipDetailed);
  };

  const handleClickAway = () => {
    setIsChipDetailed(false);
  };

  const detailedChip = (
    <div role="button" className={classes.detailedChip}>
      <div>
        <Typography variant="body1" component="span">
          {option.fullName}
        </Typography>
        <br />
        <Typography variant="body2" component="span">
          {option.contact}
        </Typography>
      </div>
      <Typography component="span" variant="body1" className={classes.closeIcon}>
        <CloseIcon />
      </Typography>
    </div>
  );
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Chip
        {...props}
        onClick={toggleDetailedView}
        style={{
          position: 'relative',
          background: '#0000000D',
          border: 'none',
          height: 30,
        }}
        label={
          isChipDetailed ? (
            <div>
              {label}
              {detailedChip}
            </div>
          ) : (
            label
          )
        }
      />
    </ClickAwayListener>
  );
};

DetailedChip.propTypes = {};

DetailedChip.defaultProps = {
  classes: {},
};

export default DetailedChip;
